export const USER_TOKEN_KEY = 'todai-app.user.token';
export const CURRENT_ENTITY_ID = 'todai-app.current.entity.id';
